/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Services\ParkService\ParkService.ts
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Tuesday July 4th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Sunday, 14th January 2024 04:51:59
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import Config from "Config/Config";
import { ParkSendType, ParkType } from "Type/park.type";
import { buildAxiosHeader } from "Utils/Request.utils";
import Axios from "axios";

class ParkService {
    static async getAllParks() {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.PARKS}`;
        const myParks = await Axios.get(myUrl, buildAxiosHeader());
        return myParks.data;
    }

    static async CreatePark(data: ParkSendType) {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.PARKS}`;
        const myRet = await Axios.post(myUrl, data, buildAxiosHeader());
        return myRet;
    }

    static async UpdatePark(data: ParkType) {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.PARKS}/${data.id}`;
        const myRet = await Axios.put(myUrl, data, buildAxiosHeader());
        return myRet;
    }

    // static async deletePark(parkID: string) {
    //     const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.PARKS}/${parkID}`;
    //     try {
    //         const myRet = await Axios.delete(myUrl, buildAxiosHeader());
    //         return myRet.data;
    //     } catch (error: any) {
    //         return error.request.status;
    //     }
    // }

    static async getParkBySearch(search: string) {
        const myUrl = `${Config.BACKEND.BASEURL}${Config.BACKEND.PATHS.PARKS}/search/${search}`;
        try {
            const myRet = await Axios.get(myUrl, buildAxiosHeader());
            if (myRet.data) {
                return myRet.data.map((v: any ) => {return {label: `${Object.entries(v).filter(x => x[0] !== "CreatedAt").map(x => x[1]).filter(x => x).reverse().join(", ")}`, result: v}});
            } else {
                return [];
            }
        } catch (error) {
            return [];
        }
    }

}

export default ParkService;
